import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import queryString from 'query-string'

import { resetPassword } from '../../actions/resetPassword'
import { withAuth } from '@auth/auth-context'

import '../Login/Login.scss'
import logo from '../../assets/reggora-app.png'
import {
  DEFAULT_ROUTE,
} from '@constants/routes'

import InputField from '../Shared/InputField/InputField'
import { LoadingOutlined } from '@ant-design/icons'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import { Button, notification } from 'antd'
import PasswordRequirements from '@reggora_shared_ui/components/PasswordRequirements'

class ResetPassword extends Component {
    state = {
      password: '',
      password2: '',
      passwordError: false,
      password2Error: false,
      isAwaitingMessage: false,
      passwordRequirementsMet: false,
    };

    componentDidUpdate() {
      const { didReset, error } = this.props
      const { password, didLogin, isAwaitingMessage } = this.state
      if (isAwaitingMessage) {
        if (error) {
          const config = {
            message: 'Error',
            description: error,
          }
          notification.error(config)
          this.setState({
            isAwaitingMessage: false,
          })
        } else if (didReset && !didLogin) {
          // successful reset, so log them in
          const { username, source } = queryString.parse(this.props.location.search)
          if (source === 'web') {
            const creds = {
              username: username,
              password: password,
            }
            this.props.auth.login(creds)
            this.setState({
              didLogin: true,
            })
            return
          }
          const config = {
            message: 'Password was succesfully changed',
          }
          notification.success(config)
        }
      }
    }

    onChange = (field) => {
      this.setState({
        [field.name]: field.value,
        [field.name + 'Error']: field.error,
      })
    }

    getConditionalContent = () => {
      const { isResetting } = this.props
      const { password, password2 } = this.state

      if (isResetting) {
        return <LoadingOutlined />
      } else if (password !== password2) {
        return (
          <div className='error'>
            Please enter two matching passwords.
          </div>
        )
      }
    }

    handleRequirementsChange = (met) => {
      this.setState({
        passwordRequirementsMet: met,
      })
    }

    validate = () => {
      const { password, password2, passwordError, password2Error, passwordRequirementsMet } = this.state
      return (password && password2 && !passwordError && !password2Error &&
              (password === password2) && passwordRequirementsMet)
    }

    onSubmit = (e) => {
      e.preventDefault()
      if (this.validate()) {
        this.props.actions.resetPassword(this.props.match.params.token, this.state.password)
        this.setState({
          isAwaitingMessage: true,
        })
      }
    }

    render() {
      const {
        currentUser,
      } = this.props
      const { password, password2 } = this.state
      if (currentUser && Object.keys(currentUser).length) {
        return (
          <Redirect
            to={{
              pathname: `/${DEFAULT_ROUTE}`,
            }}
          />
        )
      }
      return (
        <div>
          <div className='login'>
            <div className="logoContainer">
              <img src={logo} className='login-form-logo' />
            </div>
            <div className="shadowWrapper">
              <Form className='login-form' onSubmit={this.onSubmit} data-testid="reset-password-form">
                <h1>Welcome</h1>
                <h2>Login to get started!</h2>
                <div style={{ padding: '0 20px' }}>
                  <label>
                    <p>new password</p>
                    <InputField
                      name='password'
                      onChange={this.onChange}
                      placeholder='new password'
                      value={password}
                      icon='lock'
                      type='password'
                      data-testid="reset-password-input"
                    />
                  </label>
                  <label>
                    <p>confirm new password</p>
                    <InputField
                      name='password2'
                      onChange={this.onChange}
                      placeholder='confirm new password'
                      value={password2}
                      icon='lock'
                      type='password'
                      data-testid="reset-password-confirm-input"
                    />
                  </label>
                  <PasswordRequirements
                    password={this.state.password}
                    confirmPassword={this.state.password2}
                    onRequirementsChange={this.handleRequirementsChange}
                  />
                  <Button
                    htmlType='submit'
                    disabled={!this.validate()}
                    data-testid="reset-password-submit-button"
                  >
                    Change Password
                  </Button>
                </div>
              </Form>
              {this.getConditionalContent()}
            </div>
          </div>
        </div>
      )
    }
}

function mapStateToProps(state) {
  return {
    isResetting: state.resetPassword.isResetting,
    didReset: state.resetPassword.didReset,
    currentUser: state.currentUser.currentUser,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ resetPassword }, dispatch),
  }
}

export default withAuth(connect(mapStateToProps, mapDispatchToProps)(ResetPassword))
